import { Component, Input, Output, EventEmitter, input } from "@angular/core";
import { ButtonIconType } from "src/app/components/ui/button/button-icon/button-icon.component";

@Component({
  selector: "snoots-page-detail-header-action",
  template: "",
  standalone: false
})
export class PageDetailHeaderActionComponent {
  @Input()
  title: string = "";

  @Input()
  icon: string = "";

  @Input()
  disabled: boolean = false;

  type = input<ButtonIconType>("default");

  @Output()
  onClick: EventEmitter<void> = new EventEmitter<void>();
}
